export default {
      id: "dart-logo-usage",
      viewBox: "0 0 114 37",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#dart-logo",
      toString: function () {
        return this.url;
      }
    }